import { Router } from '@angular/router';
import { RouterPath } from '@app/@core/constants/router-path';
import { NbMenuItem } from '@nebular/theme';

export const DEFAULT_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Customers',
    icon: 'users',
    link: RouterPath.Customers,
  },
  {
    title: 'Invoices',
    icon: 'file-alt',
    link: RouterPath.Invoices,
  },
  {
    title: 'Routes',
    icon: 'route',
    link: RouterPath.Routes,
    children: [
      {
        title: 'Route',
        link: RouterPath.Routes,
      },
      {
        title: 'Route Allocation',
        link: RouterPath.Allocation,
      },
    ],
  },
  {
    title: 'Messages',
    icon: 'bullhorn',
    link: RouterPath.Messages,
    data: {
      permission: 'view',
      resource: RouterPath.Messages,
    },
  },
  // {
  //   title: 'Drivers',
  //   icon: {
  //     icon: 'steerwheel',
  //     pack: 'menu-sidebar-icon',
  //   },
  //   link: RouterPath.Drivers,
  // },
  {
    title: 'Vehicles',
    icon: 'truck',
    link: RouterPath.Vehicles,
  },
  {
    title: 'Products',
    icon: {
      icon: 'gas',
      pack: 'menu-sidebar-icon',
    },
    link: RouterPath.Products,
    children: [
      {
        title: 'Product',
        link: RouterPath.Products,
      },
      {
        title: 'Bulk Price Update',
        link: RouterPath.ProductsBulkUpdate,
      },
    ],
  },
  {
    title: 'Users',
    icon: 'user',
    link: RouterPath.Users,
    data: {
      permission: 'view',
      resource: RouterPath.Users,
    },
  }

];

// Admin tenant Menu item
export const ADMIN_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Tenants',
    icon: {
      icon: 'tenant',
      pack: 'menu-sidebar-icon',
    },
    link: RouterPath.Tenants,
    data: {
      permission: 'view',
      resource: RouterPath.Tenants,
    },
  },
  {
    title: 'Users',
    icon: {
      icon: 'user',
      pack: 'menu-sidebar-icon',
    },
    link: RouterPath.Users,
    data: {
      permission: 'view',
      resource: RouterPath.Users,
    },
  },
  {
    title: 'Billing',
    icon: 'file-invoice-dollar',
    link: RouterPath.Billings,
    data: {
      permission: 'view',
      resource: RouterPath.Billings,
    },
  },
  {
    title: 'Messages',
    icon: 'bullhorn',
    link: RouterPath.Messages,
    data: {
      permission: 'view',
      resource: RouterPath.Messages,
    },
  },
];
